import RealEstateCard from '@/components/real-estate-card/real-estate-card';
export default RealEstateCard;
